import React from 'react';
import { motion } from 'framer-motion';

interface TextCardProps {
  heading?: string;
  headingFont?: 'default' | 'serif' | 'sans';
  headingAlign?: 'left' | 'center' | 'right';
  bodyText?: string;
  bodyFont?: 'default' | 'serif' | 'sans';
  borderRadius?: number;
  shadowLevel?: 'none' | 'sm' | 'md' | 'lg';
}

const TextCard: React.FC<TextCardProps> = ({
  heading = 'Heading Text',
  headingFont = 'default',
  headingAlign = 'left',
  bodyText = '<p>Body text goes here...</p>',
  bodyFont = 'default',
  borderRadius = 12,
  shadowLevel = 'md',
}) => {
  const getFontFamilyClass = (font: string): string => {
    switch (font) {
      case 'serif':
        return 'font-serif';
      case 'sans':
        return 'font-sans';
      default:
        return '';
    }
  };

  const getTextAlignClass = (align: string): string => {
    switch (align) {
      case 'left':
        return 'text-left';
      case 'center':
        return 'text-center';
      case 'right':
        return 'text-right';
      default:
        return 'text-left';
    }
  };

  const getShadowClass = (level: string): string => {
    switch (level) {
      case 'none':
        return '';
      case 'sm':
        return 'shadow-sm';
      case 'md':
        return 'shadow-md';
      case 'lg':
        return 'shadow-lg';
      default:
        return 'shadow-md';
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className={`bg-white p-6 border border-gray-100 ${getShadowClass(shadowLevel)}`}
      style={{ borderRadius: `${borderRadius}px` }}
    >
      {/* Heading */}
      {heading && (
        <h2
          className={`text-2xl font-bold mb-4 ${getTextAlignClass(headingAlign)} ${getFontFamilyClass(headingFont)}`}
        >
          {heading}
        </h2>
      )}

      {/* Body Text */}
      {bodyText && (
        <div
          className={`prose max-w-none ${getFontFamilyClass(bodyFont)}`}
          dangerouslySetInnerHTML={{ __html: bodyText }}
        />
      )}
    </motion.div>
  );
};

export default TextCard;
